import { AUTH_URL, CURRENT_USER_QUERY_KEY } from '.';
import { APIClient } from '..';

export const getCurrentUser = (apiClient: APIClient) => ({
    key: CURRENT_USER_QUERY_KEY,
    fetch: () => apiClient.get(`${AUTH_URL}/current-user`),
});
